export default (theme) => ({
  chatList: {
    position: 'relative',
    padding: '10px 0 39px 0',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    width: 'calc(100% / 12 * 4 - 20px)',
    height: '100%',
    overflow: 'hidden',
    boxShadow: theme.custom.boxShadow,
    WebkitBoxShadow: theme.custom.boxShadow,
    borderRadius: 33,
    background: theme.palette.background.white,
    [theme.breakpoints.down('xl')]: {
      padding: '0 0 39px 0',
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  messagesWrapper: {
    height: '100%',
    width: '100%',
    overflowY: 'auto',
    marginTop: 15,
  },
  caption: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
    textAlign: 'center',
  },
  info: {
    textAlign: 'center',
    marginBottom: '25px',
  },
  scrollWrapper: {
    position: 'relative',
    width: '100%',
    padding: '10px 20px 15px 25px',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('md')]: {
      padding: '10px 12px 15px 25px',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '10px 20px 15px 25px',
    },
  },
  count: {
    marginLeft: 5,
    display: 'inline-flex',
    verticalAlign: 'middle',
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: 22,
    width: 'auto',
    padding: '5px 4px',
    height: 22,
    fontSize: 14,
    backgroundColor: '#cd2026',
    color: theme.palette.background.default,
    borderRadius: 50,
  },
  shadow: {
    width: 'calc(100% - 40px)',
    '&:after': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      height: 75,
      boxShadow: '0px -85px 14px -30px rgb(255 255 255) inset',
    },
  },
  message: {
    position: 'relative',
    padding: '10px 20px',
    backgroundColor: theme.palette.background.default,
    boxShadow: theme.custom.boxShadow,
    WebkitBoxShadow: theme.custom.boxShadow,
    borderRadius: 10,
    marginBottom: 20,
    minHeight: 78,
    width: '100%',
    boxSizing: 'border-box',
    cursor: 'pointer',
    [theme.breakpoints.down('md')]: {
      minHeight: 78,
      padding: '16px 12px',
    },
    [theme.breakpoints.down('sm')]: {
      minHeight: 58,
    },
  },
  selectedMessage: {
    backgroundColor: theme.palette.primary.main,
    '& p': {
      color: theme.palette.background.default,
    },
  },
  unreadMessage: {
    position: 'relative',
    '&:before': {
      content: '""',
      position: 'absolute',
      right: 'calc(100% + 10px)',
      top: '50%',
      transform: 'translateY(-50%)',
      width: 10,
      height: 10,
      borderRadius: 25,
      backgroundColor: theme.palette.primary.main,
    },
  },
  userAvatar: {
    margin: '6px 20px 0 0',
    color: theme.palette.background.white,
    '& .MuiAvatar-root': {
      width: 46,
      height: 46,
      [theme.breakpoints.down('sm')]: {
        width: 36,
        height: 36,
      },
    },
    [theme.breakpoints.down('md')]: {
      margin: '0 20px 0 0',
      '& div': {
        fontSize: 14,
      },
    },
    [theme.breakpoints.down('sm')]: {
      margin: '6px 20px 0 0',
    },
  },
  date: {
    margin: 0,
    position: 'absolute',
    top: 8,
    right: 10,
    fontSize: 12,
    color: theme.palette.font.main,
  },
  messageWrapper: {
    width: '100%',
    display: 'flex',
  },
  heading: {
    fontWeight: 'bold',
    width: 'calc(100% - 70px)',
    textTransform: 'capitalize',
  },
  bodyWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: 'calc(100% - 70px)',
  },
  body: {
    transform: 'translateY(-6px)',
  },
  tabsContainer: {
    justifyContent: 'center',
  },
  tabsHeader: {
    width: '100%',
    height: 'auto',
  },
  tab: {
    width: '50%',
    textTransform: 'capitalize',
  },
  activeTabWrap: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  reOpenButton: {
    height: 25,
    position: 'absolute',
    bottom: 5,
    right: 5,
  },
  reOpenButtonText: {
    fontSize: 11,
  },
});
